import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import * as type_btn from '../../../../../../ressources/glossaires/glossaire_type_de_bouton';
import * as s from '../../../../../../ressources/StyleGlobal/StyleGlobal';
import Bouton from '../../../../../UI/Bouton/Bouton';
import Style from '../../ArborescenceProjets.module.scss';
import GrapheTauxDePannes from './GrapheTauxDePannes/GrapheTauxDePannes';
import S from './GrapheTauxDePannesConteneur.module.scss';

const affichagePetit = '5.9% 0.1% 0% 15.2%';
const affichageGrand = '0% 0% 0% 0%';

const GrapheTauxDePannesConteneur = ({
  afficherExpand: initialAfficherExpand,
  width: propWidth,
  popup_id,
  hideHeader,
  headerPopupText,
  afficherLien,
  icone,
  texte_ouverture,
  eventAuClique,
  start_interval,
  end_interval,
  criticity_id_list,
  types_id_list,
  projects_id,
  project_id,
}: any) => {
  const [showModal, setShowModal] = useState(false);
  const [overflowX, setOverflowX] = useState('auto');
  const [overflowY, setOverflowY] = useState('auto');
  const [inset, setInset] = useState(
    initialAfficherExpand ? affichageGrand : affichagePetit
  );
  const [afficherExpand, setAfficherExpand] = useState(
    initialAfficherExpand || false
  );

  useEffect(() => {
    setInset(propWidth === '100%' ? '5.9% 0.1% 0% 0%' : '5.9% 0.1% 0% 15.2%');
  }, [propWidth]);

  // Modal management functions
  const toggleShowModal = () => {
    setShowModal((prev) => !prev);
    if (typeof eventAuClique === 'function') {
      eventAuClique();
    }
  };

  // Modal size management
  const handleModalSize = (isExpanded: any) => {
    if (isExpanded) {
      setInset('0% 0% 0% 0%');
      setAfficherExpand(true);
      setOverflowX('hidden');

      const popupElement = document.getElementById(popup_id);
      if (popupElement) {
        popupElement.requestFullscreen();
      }
    } else {
      setInset(affichagePetit);
      setAfficherExpand(false);
      setOverflowX('auto');
      setOverflowY('auto');

      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    }
  };

  // Render header based on hideHeader prop
  const renderHeader = () => {
    let colorBg = [s.text_right, s.col_1];
    let classpopup = [s.row, s.text_right];
    let Textheader;

    if (!hideHeader) {
      classpopup.push([s.card_header, S.styleB].join(' '));
      Textheader = (
        <span className={[S.headerText, s.col_11].join(' ')}>
          {headerPopupText}
        </span>
      );
    } else {
      colorBg.push(S.headerTextD);
      Textheader = (
        <span className={[S.headerTextD, s.col_11].join(' ')}>
          {headerPopupText}
        </span>
      );
    }

    return { colorBg, classpopup, Textheader };
  };

  // Generate expand/collapse button based on current state
  const renderExpandButton = () => (
    <Bouton
      ajoutClass={[S.PositionBoutonFermeture, S.BoutonOutil].join(' ')}
      type={afficherExpand ? type_btn.Min : type_btn.Max}
      rond={true}
      cliquer={() => handleModalSize(!afficherExpand)}
    />
  );

  const { colorBg, classpopup, Textheader } = renderHeader();

  return (
    <>
      {afficherLien ? (
        <button
          type="button"
          onClick={toggleShowModal}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            color: 'inherit',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {icone}
          {texte_ouverture}
        </button>
      ) : (
        <Bouton ajoutClass={Style.bouton} cliquer={toggleShowModal}>
          {icone}
          {texte_ouverture}
        </Bouton>
      )}
      <Modal
        id={popup_id}
        isOpen={showModal}
        onRequestClose={toggleShowModal}
        style={{
          overlay: {
            position: 'absolute',
            zIndex: '1000',
            border: 'black 1px solid',
            backgroundColor: 'transparent',
            transition: 'width 2s, height 4s',
          },
          content: {
            overflowX,
            overflowY,
            inset,
            padding: '0px',
            boxShadow: '-5px 0px 5px rgba(0, 0, 0, 0.226)',
          },
        }}
      >
        <div className={classpopup.join(' ')}>
          {Textheader}
          <span className={colorBg.join(' ')}>
            {renderExpandButton()}
            <Bouton
              ajoutClass={S.PositionBoutonFermeture}
              type={type_btn.fermer}
              rond={true}
              cliquer={toggleShowModal}
            />
          </span>
        </div>
        <GrapheTauxDePannes
          start_interval={start_interval}
          end_interval={end_interval}
          criticity_id_list={criticity_id_list}
          types_id_list={types_id_list}
          projects_id={projects_id}
          project_id={project_id}
        />
      </Modal>
    </>
  );
};

export default GrapheTauxDePannesConteneur;
